module.exports = __webpack_public_path__ + "10f8aa8e87c0c3ad86c7880970dcb1f8.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-Regular.eot
// module id = 697
// module chunks = 0